import React from 'react';
import { Button, Collapse } from 'antd';
import { TeamOutlined } from '@ant-design/icons';

import { AppStore } from 'stores';
import UploadCsvForm from 'containers/Form/UploadServiceForm';
import ServiceHistoryForm from 'containers/Form/ServiceHistoryForm';

const ServiceHistory = () => {
  const items = [
    {
      key: 'uploadCSV',
      label: 'Upload CSV',
      children: <UploadCsvForm />,
    },
    {
      key: 'connectDMS',
      label: 'Connect with DMS',
      children: (
        <Button
          onClick={() =>
            AppStore.addSuccess('A customer team will get back to you. Thanks!')
          }
        >
          <TeamOutlined />
          Connect with DMS
        </Button>
      ),
    },
    {
      key: 'serviceHistoryForm',
      label: 'Service History Form',
      children: <ServiceHistoryForm />,
    },
  ];

  return (
    <>
      <h5>Upload Service History/Repair Order Data</h5>
      <p>Choose one of these options</p>

      <Collapse accordion items={items} />
    </>
  );
};

export default ServiceHistory;
